import { createContext, useState } from 'react';
import API from 'services/api';
import _ from 'lodash';
import { scrollUpTo } from 'utils/scrollUpTo';
import { toast } from 'react-hot-toast';

export const PatentContext = createContext({});

const PatentProvider = props => {
	const [patentlist, setPatentList] = useState([]);
	const [patentApplicant, setPatentApplicant] = useState([]);
	const [detailPatent, setDetailPatent] = useState({});
	const [tasklists, setTasklists] = useState([]);

	const [existingList, setExistingList] = useState([]);

	const [renewalPayments, setRenewalPayments] = useState([]);
	const [renewalObj, setRenewalObj] = useState({});

	const [activeRenewal, setActiveRenewal] = useState({});
	const [customField, setCustomField] = useState({});

	const [recordalData, setRecordalData] = useState({});
	const [recordalFrom, setRecordalFrom] = useState({});

	// REJECTED/WITHDRAWN
	const [isWithdrawn, setIswithdrawn] = useState(false);
	const [isRejected, setIsRejected] = useState(false);

	const [pagination, setPagination] = useState({});
	const [isLoading, setIsLoading] = useState(false);

	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);

	const [error, setError] = useState(false);
	const [open, setOpen] = useState(false);

	const [languange, setLanguage] = useState('EN');
	const [withInv, setWithInv] = useState(false);

	// dialog annuity
	const [openAnnuty, setOpenAnnuity] = useState(false);
	const [annuityData, setAnnuityData] = useState(null);
	const [arrayAnnuities, setArrayAnnuities] = useState([]);

	// PGA OA
	const [pgaData, setPgaData] = useState(null);
	const [pgaAgree, setPgaAgree] = useState(false);

	// VLA Voluntary
	const [vlaData, setVlaData] = useState(null);
	const [vlaAgree, setVlaAgree] = useState(false);

	// office action state
	const [eventValue, setEventValue] = useState(null);
	const [matterList, setMatterList] = useState([]);

	// POP UP APPLICATIONS
	const [selected, setSelected] = useState([]); //popup existing form
	const [applist, setAppList] = useState({});

	// HANDLE FILTER
	const [fdate, setFdate] = useState(null);
	const [fsearch, setFSearch] = useState(null);
	const [frole, setFrole] = useState(null);
	const [searchUser, setSearchUser] = useState(null);
	const [searchAssociate, setSearchAssociate] = useState(null);
	const [openCustomFilter, setOpenCustomFilter] = useState({ open: false });

	const [deadlineExtends, setDeadlineExtends] = useState(null);
	const [openExtend, setOpenExtend] = useState(false);

	const [selectedRows, setSelectedRows] = useState([]);
	const [openMove, setOpenMove] = useState(false);

	// OPEN MOVE
	const onOpenMove = () => {
		setOpenMove(!openMove);
	};

	// ANNUITY HANDLER
	const onClickAnnuity = () => {
		setOpenAnnuity(!openAnnuty);
	};

	const onResetFilter = () => {
		setOpenCustomFilter({});
		setFSearch(null);
		setFdate(null);
		setFrole(null);
		// setSearchUser(null)
		setSearchAssociate(null);
		setPage(0);
	};

	const getExtendHistories = async id => {
		try {
			let result = await API.getExtendHistories(id);
			let data = await result?.data;
			setDeadlineExtends(data);
		} catch (error) {
			setError(error);
		}
	};

	const onOpenExtendHistory = async taskID => {
		try {
			await getExtendHistories(taskID);
			setOpenExtend(true);
		} catch (error) {
			toast.error('Something wrong1');
		}
	};

	// SUBMIT INVOICE MANUAL
	const onOpenForm = () => {
		setOpen(!open);
	};

	const doSubmitInvoiceManual = async id => {
		let newData = {
			manualInvoice: detailPatent?.manualInvoice,
		};

		try {
			await API.putPatentNormal(id, newData);
			toast.success('Update success!');
			onOpenForm();
		} catch (error) {
			toast.error('Update failed!');
		}
	};

	// HANDLE PAGINATION
	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = event => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
		scrollUpTo(0);
	};

	const fetchExisting = async params => {
		let newParams = { page: page + 1, pageSize: rowsPerPage, ...params };

		setIsLoading(true);

		try {
			let { data } = await API.getListPatent({ params: newParams });
			setAppList(data);
		} catch (error) {
			setError(error);
		} finally {
			setIsLoading(false);
		}
	};

	const getExistRecordal = async params => {
		let newParams = { page: page + 1, pageSize: rowsPerPage, ...params };

		setIsLoading(true);

		try {
			let { data } = await API.getExistRecordal({ params: newParams });
			setExistingList(data);
		} catch (error) {
			setError(error);
		}
		setIsLoading(false);
	};

	const getExistRenewal = params => {
		let newParams = { page: page + 1, pageSize: rowsPerPage, ...params };

		// setIsLoading(true)

		API.getExistRenewal({ params: newParams })
			.then(response => {
				const { data } = response;
				setExistingList(data);
				// setIsLoading(false)
			})
			.catch(error => {
				setError(error);
				// setIsLoading(false)
			});
	};

	// get list patent
	const getListPatent = params => {
		let newParams = { page: page + 1, pageSize: rowsPerPage, ...params };
		// console.log('newParams', newParams);
		setIsLoading(true);
		API.getListPatent({ params: newParams })
			.then(response => {
				const { data } = response;
				const result = data?.data;
				// console.log('data paten content', result);
				setPatentList(result);
				setPagination(data?.pagination);
				setIsLoading(false);
			})
			.catch(error => {
				setError(error);
				setIsLoading(false);
			});
	};

	const getFilingPatent = params => {
		const customParams = {
			efiling: true,
			page: page + 1,
			pageSize: rowsPerPage,
			...params,
		};
		setIsLoading(true);

		API.getListPatent({ params: customParams })
			.then(response => {
				const { data } = response;
				const result = data?.data;
				setPatentList(result);
				setPagination(data?.pagination);
				setIsLoading(false);
			})
			.catch(error => {
				toast.error(error);
				setIsLoading(false);
			});
	};

	const getPatentByID = (id, params) => {
		API.getPatentByID(id, params)
			.then(res => {
				const { data } = res;
				let newPGA = data?.pgaData || data?.applications;
				let isOA =
					data?.oaStatus === 'progress' ||
					data?.currentStatus === 'Office Action';

				setTasklists(data?.tasks || []);
				setDetailPatent(data);
				setAnnuityData(data?.annuityData || null);

				if (isOA) {
					setPgaData(newPGA);
				}
			})
			.catch(err => {
				throw err;
			});
	};

	const postPatent = data => {
		API.postPatent(data)
			.then(res => {
				const { data } = res;
				return data;
			})
			.catch(err => {
				throw err;
			});
	};

	const postGenerateRefPatent = async data => {
		try {
			let result = await API.postGenerateRefPatent(data);
			return result?.data;
		} catch (error) {
			throw error;
		}
	};

	const postGenRefSearch = data => {
		API.postGenRefSearch(data)
			.then(res => {
				const data = res?.data;
				return data;
			})
			.catch(err => {
				throw err;
			});
	};

	const putPatent = async (_id, data) => {
		try {
			const res = await API.putPatent(_id, data);
			const responseData = res?.data;
			// console.log('data dari context', responseData);
			return responseData;
		} catch (err) {
			console.error('Error:', err);
			throw err;
		}
	};

	const putPatentNormal = async (_id, data) => {
		try {
			let result = await API.putPatentNormal(_id, data);
			return result.data;
		} catch (error) {
			throw error;
		}
	};

	const putManyPatent = data => {
		API.putManyPatent(data)
			.then(res => {
				return res;
			})
			.catch(err => {
				throw err;
			});
	};

	const deletePatent = id => {
		API.deletePatent(id)
			.then(res => {
				const { data } = res;
				return data;
			})
			.catch(err => {
				throw err;
			});
	};

	const getOAPatent = params => {
		// const customParams = { page: page + 1, pageSize: rowsPerPage, ...params };
		const customParams = { page: page + 1, pageSize: 1000, ...params };
		setIsLoading(true);
		API.getOAPatent({ params: customParams })
			.then(response => {
				let { data } = response;
				let result = data?.data;
				setPatentList(result);
				setPagination(data?.pagination);
				setIsLoading(false);
			})
			.catch(error => {
				setError(error);
				toast.error(error);
				setIsLoading(false);
			});
	};

	const postOAMatterPatent = body => {
		setIsLoading(true);
		API.postOAMatterPatent(body)
			.then(response => {
				setIsLoading(false);
			})
			.catch(error => {
				setIsLoading(false);
				throw error;
			});
	};

	const putManyOAMatterPatent = data => {
		API.putManyOAMatterPatent(data)
			.then(res => {
				const { data } = res;
			})
			.catch(err => {
				console.log('err', err);
			});
	};

	const getMatterPatentbyParentID = id => {
		setIsLoading(true);
		API.getMatterPatentbyParentID(id)
			.then(response => {
				let { data } = response;
				setMatterList(data);
				setIsLoading(false);
			})
			.catch(error => {
				setIsLoading(false);
				throw error;
			});
	};

	const createMatterPatent = (_id, data) => {
		setIsLoading(true);
		API.createMatterPatent(_id, data)
			.then(response => {
				let { data } = response;
				setIsLoading(false);
				return data;
			})
			.catch(error => {
				setIsLoading(false);
				throw error;
			});
	};

	const getMatterbyPatent = id => {
		API.getMatterbyPatent(id)
			.then(response => {
				const { data } = response;
				setMatterList(data);
			})
			.catch(err => {
				throw err;
			});
	};

	const updateTaskMatterPatent = (taskId, data) => {
		API.updateTaskMatterPatent(taskId, data)
			.then(response => {
				const { data } = response;
				return data;
			})
			.catch(err => {
				throw err;
			});
	};

	const updateMatterPatent = (agendaId, data) => {
		API.updateMatterPatent(agendaId, data)
			.then(response => {
				const { data } = response;
				return data;
			})
			.catch(err => {
				throw err;
			});
	};

	const createRecordalPatent = (id, data) => {
		API.createRecordalPatent(id, data)
			.then(response => {
				const { data } = response;
				return data;
			})
			.catch(err => {
				throw err;
			});
	};

	const putTaskPatent = (id, data) => {
		API.putTaskPatent(id, data)
			.then(response => {
				const { data } = response;
				return data;
			})
			.catch(err => {
				throw err;
			});
	};

	const extendDeadlineTask = (id, data) => {
		API.extendDeadlineTask(id, data)
			.then(response => {
				const { data } = response;
				return data;
			})
			.catch(err => {
				throw err;
			});
	};

	const getRecordalPatentByID = (id, params) => {
		API.getRecordalPatentByID(id, params)
			.then(response => {
				const { data } = response;
				setTasklists(data?.tasks || []);
				setRecordalData(data?.recordal?.dataChanged);
				setRecordalFrom(data?.recordal?.dataFrom);
				setDetailPatent(data);
			})
			.catch(err => {
				throw err;
			});
	};

	// FETCH MAIN
	const fetchRecordal = async () => {
		const customParams = { recordal: true };
		getListPatent(customParams);
	};

	const fetchRenewal = async () => {
		const customParams = { renewal: true };
		getListPatent(customParams);
	};

	// RENEWAL PAYMENT
	const getRenPayment = id => {
		API.getRenPayment(id)
			.then(response => {
				const { data } = response;
				setRenewalPayments(data);
			})
			.catch(err => {
				throw err;
			});
	};

	const postRenPayment = data => {
		API.postRenPayment(data)
			.then(response => {
				const { data } = response;
				return data;
			})
			.catch(err => {
				throw err;
			});
	};

	// Annuity
	const getAnnuities = id => {
		API.getAnnuities(id)
			.then(response => {
				const { data } = response;
				setArrayAnnuities(data);
			})
			.catch(err => {
				throw err;
			});
	};

	const postAnnuity = data => {
		API.postAnnuity(data)
			.then(response => {
				const { data } = response;
				return data;
			})
			.catch(err => {
				throw err;
			});
	};

	const postManyAnnuity = data => {
		API.postManyAnnuity(data)
			.then(response => {
				const { data } = response;
				console.log('data', data);
				setArrayAnnuities(data);
				return data;
			})
			.catch(err => {
				throw err;
			});
	};

	const putAnnuity = (id, data) => {
		API.putAnnuity(id, data)
			.then(response => {
				const { data } = response;
				return data;
			})
			.catch(err => {
				throw err;
			});
	};

	// Applicant
	const getListApplicant = params => {
		API.getListApplicant({params: params})
			.then(response => {
				const { data } = response;
				setPatentApplicant(data);
			})
			.catch(err => {
				throw err;
			});
	};

	return (
		<PatentContext.Provider
			value={{
				patentlist,
				getListPatent,

				postPatent,
				postGenerateRefPatent,
				postGenRefSearch,
				putPatent,
				deletePatent,

				detailPatent,
				setDetailPatent,
				getPatentByID,

				tasklists,
				setTasklists,

				getOAPatent,

				pagination,

				page,
				rowsPerPage,
				handleChangePage,
				handleChangeRowsPerPage,

				error,
				isLoading,
				setIsLoading,

				getFilingPatent,

				eventValue,
				setEventValue,

				matterList,
				setMatterList,

				getMatterPatentbyParentID,
				postOAMatterPatent,
				putManyOAMatterPatent,

				fdate,
				setFdate,
				fsearch,
				setFSearch,
				frole,
				setFrole,
				searchUser,
				setSearchUser,
				searchAssociate,
				setSearchAssociate,
				openCustomFilter,
				setOpenCustomFilter,
				onResetFilter,

				createMatterPatent,
				getMatterbyPatent,
				updateTaskMatterPatent,
				updateMatterPatent,

				recordalData,
				setRecordalData,

				createRecordalPatent,

				putTaskPatent,
				getRecordalPatentByID,

				fetchRecordal,
				fetchRenewal,

				recordalFrom,
				setRecordalFrom,

				pgaData,
				setPgaData,

				selected,
				setSelected,
				applist,

				putManyPatent,
				fetchExisting,

				existingList,
				setExistingList,

				getExistRecordal,
				getExistRenewal,

				putPatentNormal,

				renewalPayments,
				setRenewalPayments,
				renewalObj,
				setRenewalObj,

				getRenPayment,
				postRenPayment,

				doSubmitInvoiceManual,

				open,
				onOpenForm,

				activeRenewal,
				setActiveRenewal,

				customField,
				setCustomField,

				pgaAgree,
				setPgaAgree,

				vlaData,
				setVlaData,
				vlaAgree,
				setVlaAgree,

				openAnnuty,
				setOpenAnnuity,
				annuityData,
				setAnnuityData,
				arrayAnnuities,
				setArrayAnnuities,
				onClickAnnuity,

				getAnnuities,
				postAnnuity,
				postManyAnnuity,
				putAnnuity,

				extendDeadlineTask,
				deadlineExtends,
				getExtendHistories,

				openExtend,
				setOpenExtend,
				onOpenExtendHistory,

				languange,
				setLanguage,

				selectedRows,
				setSelectedRows,
				openMove,
				setOpenMove,
				onOpenMove,

				setPage,

				isWithdrawn,
				setIswithdrawn,

				isRejected,
				setIsRejected,

				withInv,
				setWithInv,

				patentApplicant,
				getListApplicant
			}}
			{...props}
		/>
	);
};

export default PatentProvider;
